import React from "react";
import { Navigate, useParams } from "react-router-dom";
import CatalogPageShell from "../components/Products/CatalogPageShell.jsx";
import DimensionGrid from "../components/Products/DimensionGrid.jsx";
import BoxPacking from "./BoxPacking.jsx";

const attachmentCount = (key) => (row) =>
    Array.isArray(row?.[key]) && row[key].length ? String(row[key].length) : "";

export const CATALOG_TABLES = {
    brands: {
        title: "Brands",
        singular: "Brand",
        subtitle: "Brand Cipher table. Name and the 4 character cipher used in Internal SKU ID.",
        endpoint: "broylesllc/brands",
        fields: [
            { key: "name", label: "Name", required: true },
            { key: "cipher", label: "4 Character Cipher" },
        ],
    },
    sizes: {
        title: "Sizes",
        singular: "Size",
        subtitle: "Size Cipher table. Name and the 2–6 character cipher used in Internal SKU ID.",
        endpoint: "broylesllc/sizes",
        fields: [
            { key: "name", label: "Name", required: true },
            { key: "cipher", label: "2-6 Character Cipher" },
        ],
    },
    colors: {
        title: "Colors",
        singular: "Color",
        subtitle:
            "Color Cipher table. Name and the 2–6 character cipher for color, flavor, title, or variety.",
        endpoint: "broylesllc/color-flavors",
        fields: [
            { key: "name", label: "Name", required: true },
            { key: "cipher", label: "2-6 Character Cipher" },
        ],
    },
    models: {
        title: "Models",
        singular: "Model",
        subtitle: "Model Cipher table. Name and the 2–6 character cipher used in Internal SKU ID.",
        endpoint: "broylesllc/models",
        fields: [
            { key: "name", label: "Name", required: true },
            { key: "cipher", label: "2-6 Character Cipher" },
        ],
    },
    "status-checks": {
        title: "Status Checks",
        singular: "Status Check",
        subtitle: "Status Checks - Buying. Title is edited here. Example photos stay on the record.",
        endpoint: "broylesllc/status-checks",
        fields: [{ key: "name", label: "Title", required: true }],
        readOnly: [
            {
                key: "positiveExamples",
                label: "Positive Examples",
                value: attachmentCount("positiveExamples"),
                source: "Photos on this status check",
            },
            {
                key: "negativeExamples",
                label: "Negative Examples",
                value: attachmentCount("negativeExamples"),
                source: "Photos on this status check",
            },
        ],
    },
};

export default function CatalogRecords() {
    const { table } = useParams();
    if (table === "box-packing") return <BoxPacking />;
    const spec = CATALOG_TABLES[table];
    if (!spec) return <Navigate to="/products" replace />;
    return (
        <CatalogPageShell title={spec.title} subtitle={spec.subtitle}>
            <DimensionGrid key={table} spec={spec} />
        </CatalogPageShell>
    );
}
